// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","948":"2cca2479","976":"c16184b3"}[chunkId] + "-" + {"678":"5886c2f5c675f534a14a","883":"5daa0bdfa15fa2d232ed","948":"08553ffe8543a207bf93","976":"042f1ffefcd4a93f03d2"}[chunkId] + ".js";
};